import React, { useRef, useState, useEffect } from 'react'
import { any } from 'prop-types'

import { Toast } from '../../components/Toast'

const NotificationContext = React.createContext()

const NotificationContextProvider = ({ children }) => {
  const [show, setShow] = useState(false)
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const timeoutRef = useRef()

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setShow(false)
    }, 10000)
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [show])

  const triggerNotification = (message, error = false) => {
    setError(error)
    setMessage(message)
    setShow(true)
  }

  const handleToastClose = () => {
    setShow(false)
    clearTimeout(timeoutRef.current)
  }

  return (
    <NotificationContext.Provider value={{ triggerNotification }}>
      <Toast error={error} message={message} show={show} setShow={handleToastClose} />
      {children}
    </NotificationContext.Provider>
  )
}

NotificationContextProvider.propTypes = {
  children: any,
}

const useNotificationContext = () => {
  const context = React.useContext(NotificationContext)
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationContextProvider')
  }
  return context
}

export { NotificationContextProvider, useNotificationContext }
